export default {"src":"/_next/static/media/THB.2f4af9de.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};